import React from 'react'
import { useIntl } from 'react-intl'
import { Pressable } from 'react-native'

import { tID } from '../../utils/utils'
import { ClientMessagingAiIcon } from '../icons/ClientMessagingAiIcon'
import { ClientMessagingIcon } from '../icons/ClientMessagingIcon'
import { ClientMessagingUnreadIcon } from '../icons/ClientMessagingUnreadIcon'

interface HeaderMessagingIconProps {
  showGenAi?: boolean
  showUnread?: boolean
  onPress?: () => void
  isExpanded?: boolean
  testID?: string
  hitSlop?: number
}

export const HeaderMessagingIcon: React.FC<HeaderMessagingIconProps> = ({
  showGenAi,
  showUnread,
  onPress,
  isExpanded = false,
  testID = 'MessageIcon',
  hitSlop,
}) => {
  const { formatMessage } = useIntl()
  return (
    <Pressable
      testID={tID(testID)}
      role='button'
      aria-label={formatMessage({
        defaultMessage: `Messenger`,
        description: 'Messaging icon button that can display a badge to indicate unread messages',
      })}
      aria-expanded={isExpanded}
      onPress={onPress}
      accessible
      accessibilityRole='button'
      hitSlop={hitSlop}
    >
      {showGenAi ? <ClientMessagingAiIcon /> : showUnread ? <ClientMessagingUnreadIcon /> : <ClientMessagingIcon />}
    </Pressable>
  )
}
